import {ExtraFee} from "./extra-fee";
import {CustomGroup} from "./group/custom-group";
import {EnumQuoteType} from "../../enum/enum-quote-type";
import {EnumQuoteServiceSalesType} from "./enum-quote-service-sales-type";
import {EnumDisplayMode} from "./enum-display-mode";
import {DeviceConsumableLink} from "./device-consumable-link";
import {PricingItem} from "./pricing-item/pricing-item";
import {parseBig} from "../../../utils/math-utils";

export class QuoteService {

    public code?: string;
    public contractInfoInputs?: any;
    public appliedPrice?: string;
    public appliedPriceColor?: string;
    public appliedPriceDevices?: string;
    public appliedPriceConsumables?: string;
    public appliedPriceDevicesColor?: string;
    public appliedPriceConsumablesColor?: string;
    public distance?: string;
    public pct?: string;
    public averagePctCoefficient?: string;
    public nonNegociableArticleColor?: string;
    public uniqueReferenceCoefficient?: string;

    public totalLogisticsPrice?: string;
    public factorVt?: string;
    public factorFreeMonth?: string;
    public extraFees?: ExtraFee[];
    public discount?: string;
    public isCustomGroups?: boolean;
    public customGroups?: CustomGroup[];
    public indexCustomGroup?: number;
    public quoteType?: EnumQuoteType;
    public additionalStockAmount?: string;
    public monthlyAmount?: string;
    public weeklyAmount?: string;
    public salesType: EnumQuoteServiceSalesType;
    public deviceConsumableLinks: DeviceConsumableLink[];
    public displayMode?: EnumDisplayMode;


    constructor(code: string, contractInfoInputs: any, appliedPrice: string, appliedPriceColor: string, appliedPriceDevices: string, appliedPriceConsumables: string, appliedPriceDevicesColor: string, appliedPriceConsumablesColor: string, distance: string, pct: string, averagePctCoefficient: string, nonNegociableArticleColor: string, uniqueReferenceCoefficient: string, totalLogisticsPrice: string, factorVt: string, factorFreeMonth: string, extraFees: ExtraFee[], discount: string, isCustomGroups: boolean, customGroups: CustomGroup[], indexCustomGroup: number, quoteType: EnumQuoteType, additionalStockAmount: string, monthlyAmount: string, weeklyAmount: string, salesType: EnumQuoteServiceSalesType, displayMode?: EnumDisplayMode) {
        this.code = code;
        this.contractInfoInputs = contractInfoInputs;
        this.appliedPrice = appliedPrice;
        this.appliedPriceColor = appliedPriceColor;
        this.appliedPriceDevices = appliedPriceDevices;
        this.appliedPriceConsumables = appliedPriceConsumables;
        this.appliedPriceDevicesColor = appliedPriceDevicesColor;
        this.appliedPriceConsumablesColor = appliedPriceConsumablesColor;
        this.distance = distance;
        this.pct = pct;
        this.averagePctCoefficient = averagePctCoefficient;
        this.nonNegociableArticleColor = nonNegociableArticleColor;
        this.uniqueReferenceCoefficient = uniqueReferenceCoefficient;
        this.totalLogisticsPrice = totalLogisticsPrice;
        this.factorVt = factorVt;
        this.factorFreeMonth = factorFreeMonth;
        this.extraFees = extraFees;
        this.discount = discount;
        this.isCustomGroups = isCustomGroups;
        this.customGroups = customGroups;
        this.indexCustomGroup = indexCustomGroup;
        this.quoteType = quoteType;
        this.additionalStockAmount = additionalStockAmount;
        this.monthlyAmount = monthlyAmount;
        this.weeklyAmount = weeklyAmount;
        this.salesType = salesType;
        this.displayMode = displayMode;
    }


    get pricingItems(): PricingItem[] {
        return this.customGroups.reduce((accumulator, customGroup) => accumulator.concat(customGroup.pricingItems), []);
    }

    hasPricingItemsWithQuantity(): boolean {
        return this.pricingItems.some(pricingItem => parseBig(pricingItem.userInputs.quantity).gt(0) || parseBig(pricingItem.userInputs.consumableQuantity).gt(0))
    }

    hasPricingItemsWithFranchiseConso(): boolean {
        return this.pricingItems.some(pricingItem => pricingItem.hasFranchiseConso?.() ?? false);
    }

    isServicePriced(): boolean {
        return this.hasPricingItemsWithQuantity() || this.hasPricingItemsWithFranchiseConso();
    }
}
